/* Single image */
import simg1 from '../images/service-single/1.jpg';
import simg2 from '../images/service-single/2.jpg';
import simg3 from '../images/service-single/3.jpg';
import simg4 from '../images/service-single/4.jpg';
import simg5 from '../images/service-single/5.jpg';
import simg6 from '../images/service-single/6.jpg';

const Services = [
  {
    id: 1,
    icon: 'flaticon-rehabilitation',
    simage: simg1,
    title: 'Inward',
    description:
      'Comfortable wards, trained staff and round-the-clock monitoring for patients who need to stay with us.',
    slug: 'inward-patient-care',
  },
  {
    id: 2,
    icon: 'flaticon-microsurgery',
    simage: simg2,
    title: 'Theater',
    description:
      'Modern operation theaters with advanced equipment and strict safety standards for surgical procedures.',
    slug: 'operation-theater-facilities',
  },
  {
    id: 3,
    icon: 'flaticon-mortar',
    simage: simg3,
    title: 'Emergency',
    description:
      'Emergency-ready medical team available 24 hours a day, 7 days a week, all year round.',
    slug: '24-hours-service-every-day',
  },
  {
    id: 4,
    icon: 'flaticon-bone',
    simage: simg4,
    title: 'OPD',
    description:
      'Quick and efficient outpatient care for consultations, minor treatments and regular follow-ups.',
    slug: 'outpatient-department-opd',
  },
  {
    id: 5,
    icon: 'flaticon-tooth',
    simage: simg5,
    title: 'Channeling',
    description:
      'Channel your preferred specialist at a convenient time with our organized consultation service.',
    slug: 'channel-consultation-service',
  },
  {
    id: 6,
    icon: 'flaticon-baby',
    simage: simg6,
    title: 'Labour',
    description:
      'Safe and supportive labour rooms for mothers, guided by experienced obstetric teams.',
    slug: 'labour-room-facilities',
  },
  {
    id: 7,
    icon: 'flaticon-microsurgery',
    simage: simg1,
    title: 'Xray',
    description:
      'High quality digital X-Ray imaging with fast reporting to support accurate diagnosis.',
    slug: 'digital-x-ray',
  },
  {
    id: 8,
    icon: 'flaticon-mortar',
    simage: simg2,
    title: 'Pharmacy',
    description:
      'On-site pharmacy with a wide range of genuine medicines and friendly, helpful staff.',
    slug: 'pharmacy',
  },
  {
    id: 9,
    icon: 'flaticon-baby',
    simage: simg3,
    title: 'Family',
    description:
      'Confidential family planning advice and services to support your future plans.',
    slug: 'family-planning-service',
  },
  {
    id: 10,
    icon: 'flaticon-baby',
    simage: simg4,
    title: 'Baby',
    description:
      'Regular checkups, vaccinations and growth monitoring for your little ones.',
    slug: 'healthy-baby-clinic',
  },
  {
    id: 11,
    icon: 'flaticon-microsurgery',
    simage: simg5,
    title: 'Ultrasound',
    description:
      'Detailed ultrasound scanning for pregnancy and internal organ assessment.',
    slug: 'ultra-sound-scan',
  },
  {
    id: 12,
    icon: 'flaticon-rehabilitation',
    simage: simg6,
    title: 'Physiotherapy',
    description:
      'Personalized physiotherapy plans to restore movement, strength and comfort.',
    slug: 'physiotherapy-service',
  },
  {
    id: 13,
    icon: 'flaticon-microsurgery',
    simage: simg1,
    title: 'ECG',
    description:
      'Electrocardiogram testing at rest and under exercise for complete heart evaluation.',
    slug: 'ecg-ex-ecg',
  },
  {
    id: 14,
    icon: 'flaticon-microsurgery',
    simage: simg2,
    title: 'EEG',
    description:
      'Electroencephalogram testing to study brain wave patterns and neurological conditions.',
    slug: 'eeg',
  },
  {
    id: 15,
    icon: 'flaticon-microsurgery',
    simage: simg3,
    title: 'CTG',
    description:
      'Fetal heart rate and uterine contraction monitoring for safe pregnancy care.',
    slug: 'ctg-scanning',
  },
  {
    id: 16,
    icon: 'flaticon-microsurgery',
    simage: simg4,
    title: 'Eye',
    description:
      'Specialized eye surgeries performed with precision and gentle post-operative care.',
    slug: 'eye-operation',
  },
  {
    id: 17,
    icon: 'flaticon-tooth',
    simage: simg5,
    title: 'Dental',
    description:
      'Full range of dental treatments from routine care to advanced procedures.',
    slug: 'dental-care-service',
  },
  {
    id: 18,
    icon: 'flaticon-microsurgery',
    simage: simg6,
    title: 'FNAC',
    description:
      'Fine needle aspiration cytology for accurate, minimally invasive diagnosis.',
    slug: 'fnac-test',
  },
  {
    id: 19,
    icon: 'flaticon-mortar',
    simage: simg1,
    title: 'PAP',
    description:
      'Screening test to detect early changes in cervical cells and help prevent cancer.',
    slug: 'pap-smear-test',
  },
  {
    id: 20,
    icon: 'flaticon-rehabilitation',
    simage: simg2,
    title: 'NCS',
    description:
      'Nerve conduction studies to assess the health and speed of nerve signals.',
    slug: 'ncs-test',
  },
  {
    id: 21,
    icon: 'flaticon-microsurgery',
    simage: simg3,
    title: 'Echo',
    description:
      'Echocardiogram ultrasound to view heart structure and function in real time.',
    slug: 'echo',
  },
  {
    id: 22,
    icon: 'flaticon-microsurgery',
    simage: simg4,
    title: 'Checkup',
    description:
      'Comprehensive health checkup packages tailored to your age, lifestyle and needs.',
    slug: 'medical-checkup',
  },
];

export default Services;